import PropTypes from 'prop-types';

export default PropTypes.shape({
  lat: PropTypes.number,
  lon: PropTypes.number,
});
